/* eslint-disable max-len */
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const fetchActivePriceColor = (data = {}) => {
  return apiActionCreator({
    'endpoint': `/budgets/vehicle-color-prices/${data.masterCode}/${data.sfx}/${data.startDate}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ACTIVE_PRICE_COLORS,
      ActionTypes.FETCHED_ACTIVE_PRICE_COLORS,
      [ActionTypes.FETCHED_ACTIVE_PRICE_COLORS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchEmptyPriceColor = (masterCode, sfx) => {
  return apiActionCreator({
    'endpoint': `/budgets/vehicle-color-prices-empty/${masterCode}/${sfx}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_EMPTY_PRICE_COLORS,
      ActionTypes.FETCHED_EMPTY_PRICE_COLORS,
      [ActionTypes.FETCHED_EMPTY_PRICE_COLORS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchAllActivePrices = () => {
  return apiActionCreator({
    'endpoint': '/budgets/vehicle-prices/get-all-active-prices',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ALL_ACTIVE_PRICES,
      ActionTypes.FETCHED_ALL_ACTIVE_PRICES,
      [ActionTypes.FETCHED_ALL_ACTIVE_PRICES_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchHistoryPriceColor = (data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/budgets/vehicle-prices/${data.masterCode}/${data.sfx}/${data.startDate}/${data.endDate}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_HISTORY_PRICE_COLORS,
        ActionTypes.FETCHED_HISTORY_PRICE_COLORS,
        [ActionTypes.FETCHED_HISTORY_PRICE_COLORS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'GET',
    })
  );
};

export const fetchActiveProductions = (katashiki, sfx) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/budgets/vehicle-prices/active-productions/${katashiki}/${sfx}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_ACTIVE_PRODUCTIONS,
        ActionTypes.FETCHED_ACTIVE_PRODUCTIONS,
        [ActionTypes.FETCHED_ACTIVE_PRODUCTIONS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'GET',
    })
  );
};


export const clearHistoryPriceColors = () => ({
  'type': ActionTypes.CLEAR_COLORS_HISTORY,
});

export const clearActiveColorPrices = () => ({
  'type': ActionTypes.CLEAR_ACTIVE_PRICE_COLORS,
});

export const updateColorPrice = (data, setUpdateMode) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/budgets/vehicle-prices/update',
      'authenticated': true,
      'payload': data,
      'types': [
        ActionTypes.UPDATING_ACTIVE_PRICE_COLORS,
        [
          () => {
            dispatch(fetchActivePriceColor(data.header));
            return {
              'type': ActionTypes.UPDATED_ACTIVE_PRICE_COLORS,
            };
          },
          (response) => {
            setUpdateMode('readProduction');
            return MessageActions.addMessageBoxInfo(
              `Precios actualizados correctamente. ${
                response?.updatedVehicles ?
                  `Se ha actualizado el C&F de ${response?.updatedVehicles} vehículos.` :
                  ''
              }`
            );
          },
        ],
        [ActionTypes.UPDATED_ACTIVE_PRICE_COLORS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

export const createPriceColor = (data, setUpdateMode) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/budgets/vehicle-color-prices',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_ACTIVE_PRICE_COLORS,
        [
          () => {
            dispatch(fetchActivePriceColor(data.header));
            dispatch(fetchActiveProductions(data.header.masterCode, data.header.sfx));
            return {
              'type': ActionTypes.CREATED_ACTIVE_PRICE_COLORS,
            };
          },
          (response) => {
            setUpdateMode('readProduction');
            return MessageActions.addMessageBoxInfo(
              `Producción creada correctamente. ${
                response?.updatedVehicles ?
                  `Se ha actualizado el C&F de ${response?.updatedVehicles} vehículos.` :
                  ''
              }`
            );
          },
        ],
        [ActionTypes.CREATED_ACTIVE_PRICE_COLORS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

export const editPriceColor = (data, setUpdateMode) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/budgets/vehicle-color-prices',
      'authenticated': true,
      'types': [
        ActionTypes.EDITING_ACTIVE_PRICE_COLORS,
        [
          () => {
            dispatch(fetchActivePriceColor(data.header));
            dispatch(fetchActiveProductions(data.header.masterCode, data.header.sfx));
            return {
              'type': ActionTypes.EDITED_ACTIVE_PRICE_COLORS,
            };
          },
          (response) => {
            setUpdateMode('readProduction');
            return MessageActions.addMessageBoxInfo(
              `Producción modificada correctamente. ${
                response?.updatedVehicles ?
                  `Se ha actualizado el C&F de ${response?.updatedVehicles} vehículos.` :
                  ''
              }`
            );
          },
        ],
        [ActionTypes.EDIT_ACTIVE_PRICE_COLORS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};
